import { PageLoading } from './PageLoading/page-loading';
import { PageRoot } from './PageRoot/page-root';
import { PageStreamingIndicator } from './PageStreamingIndicator/page-streaming-indicator';
import { PageTrigger } from './PageTrigger/page-trigger';

export const components = {
  PageLoading,
  PageRoot,
  PageStreamingIndicator,
  PageTrigger,
};
